<div class="reports">
	<div class="filter-data">
		<app-filter-data></app-filter-data>
	</div>

	<div class="report-details">
		<app-report-details></app-report-details>
	</div>
</div>